/**
 * True if `text` contains any Hebrew-script character. Mirrors the backend's
 * `AddressService::containsHebrewText()` — used to decide the Google Places
 * `language` request parameter PER REQUEST, from what the user actually typed,
 * rather than from workspace/account country. See MD plan for context.
 */
export const isHebrewText = (text: string): boolean => /[֐-׿]/.test(text);
